import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';
import { logout } from '../services/authService';

export const useCompanyStatus = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user || user.role !== 'company' || !user.companyId) {
      return;
    }

    // Listener em tempo real para mudanças no status da empresa
    const unsubscribe = onSnapshot(
      doc(db, 'companies', user.companyId),
      (doc) => {
        if (doc.exists()) {
          const companyData = doc.data();
          
          if (!companyData.active) {
            // Empresa foi desabilitada, fazer logout imediatamente
            logout().then(() => {
              alert('Sua empresa foi desabilitada. Entre em contato com o administrador para tratar de problemas sobre o acesso.');
              window.location.reload();
            }).catch(console.error);
          }
        } else {
          // Empresa foi deletada, fazer logout
          logout().then(() => {
            alert('Sua empresa não foi encontrada. Entre em contato com o administrador.');
            window.location.reload();
          }).catch(console.error);
        }
      },
      (error) => {
        console.error('Erro ao monitorar status da empresa:', error);
      }
    );

    return () => unsubscribe();
  }, [user]);
};
